import React, { Component } from 'react';
import moment from 'moment';

import { Table } from 'antd';

const columns = [{
    title: 'Date',
    key: 'date',
    render: (data, record) =>
        <span>{ moment(record.startTime).format('MMMM Do') }:<br/> { moment(record.startTime).format('LT') } - { moment(record.endTime).format('LT') }</span>
}, {
    title: 'Title',
    key: 'title',
    // render: (data) => <div dangerouslySetInnerHTML={{ __html: data }} />,
    dataIndex: 'course.title'
},
    {
        title: 'Site',
        key: 'site',
        dataIndex: 'site'
    },
    {
        title: 'Location',
        key: 'location',
        dataIndex: 'location'
    }];

export default class UnscheduledSessionsCard extends Component {
    render() {
        let typeLabel, site, dateLabel;
        if (typeof this.props.sessions === "undefined") return null;
        if (typeof this.props.sessions[0] === "undefined") return null;
        if (!this.props.sessions[0].course) return null;
        if (!this.props.sessions[0].course.category) return null;
        if (!this.props.sessions[0].course.category.label) return null;


        typeLabel = this.props.sessions[0].course.category.label;
        // dateLabel = typeof this.props.sessions[0].startTime === "undefined" ? 'Error reading date.' : moment(this.props.sessions[0].startTime).format('MMMM Do');
        return (
            <div className="sessions-card">
                <h3>{ typeLabel }</h3>
                <Table columns={ columns } dataSource={ this.props.sessions } pagination={ false }
                       rowKey='sessionID' bordered/>
            </div>
        );


    }
}
